import React, { FC, useContext, useEffect, useState } from 'react';
import styles from './TransactionDetails.module.scss';
import { useStore, useUpdateEffect } from '../../../../../common';
import { AuthContext } from '../../../../../logic';
import { CloseDark, Modal, Pagination, Table } from 'esa-ui-library';
import { PropertyType } from 'esa-ui-library/lib/types';
import { getRows } from '../../../PlayerTransactions/RowProvider';
import { isEmpty } from 'lodash';
import { RoundHistory } from '../../../PlayerTransactions/RoundHistory/RoundHistory';
import { filterTransactionFieldsByEnv } from './TransactionDetails.helper';

interface TransactionDetailsProps {
	session: PropertyType;
	onClose: () => void;
}

const TransactionDetails: FC<TransactionDetailsProps> = ({ session, onClose }): JSX.Element => {
	const [isLoading, setIsLoading] = useState(true);
	const [state, dispatch] = useStore(false);
	const { transactions, columnsTransactions, transactionsRows, pagesTotalTransactions, currentPageTransactions } =
		state;
	const { token } = useContext(AuthContext);
	const { session_id, game_id, game_name, player_id, game_provider_name } = session;
	const filteredSessionFields = filterTransactionFieldsByEnv(columnsTransactions);
	const [selected, setSelected] = useState<PropertyType>({ transaction: null, action: '' });

	const onAction = (action: string, transaction: PropertyType): void => {
		switch (action) {
			case 'round_history':
				setSelected({ transaction, action });
				break;
			default:
				break;
		}
	};

	const handleCloseModal = () => {
		setSelected({ transaction: null, action: '' });
	};

	useEffect(() => {
		dispatch('TRANSACTIONS_INIT', { token, page: 1, sessionID: session_id });
	}, []);

	useEffect(() => {
		dispatch('UPDATE_TRANSACTIONS_ROWS', getRows(transactions, filteredSessionFields, onAction));
	}, [transactions]);

	useUpdateEffect(() => {
		setIsLoading(false);
	}, [transactions]);

	const onPageChange = (page: number | string) => {
		dispatch('TRANSACTIONS_INIT', { token, page, sessionID: session_id });
	};

	return (
		<section className={styles.DetailsWrapper}>
			<section className={styles.DetailsContent} data-testid='transaction-details'>
				<div className={styles.Header}>
					<div data-testid='transaction-details-header'>
						<span>{`Session ID: ${session_id} | `}</span>
						<span>{`Player ID: ${player_id} | `}</span>
						<span>{`Game: ${game_name} (${game_provider_name}) | `}</span>
						<span>{`Game ID: ${game_id}`}</span>
					</div>
					<CloseDark size={24} className={styles.Close} onClick={onClose} />
				</div>
				<section className={styles.TableWrapper}>
					<Table
						titles={filteredSessionFields}
						data={transactionsRows}
						className={styles.TransactionTable}
						rowClassName={styles.TransactionRow}
						skeletonRows={3}
						isLoading={isLoading}
					/>
					{!!transactions?.length && (
						<Pagination
							total={Math.ceil(pagesTotalTransactions / 10)}
							current={currentPageTransactions}
							onChange={onPageChange}
						/>
					)}
				</section>
			</section>
			{!isEmpty(selected?.transaction) && (
				<Modal
					dataId='round-history-modal'
					primary
					confirm
					title='Round History'
					submitLabel='Got it'
					onCancel={handleCloseModal}
					onSubmit={handleCloseModal}
				>
					<RoundHistory transaction={selected?.transaction} />
				</Modal>
			)}
		</section>
	);
};

export { TransactionDetails };
